/**
 * Canonical units stored/sent to the backend for weight & macro tracking.
 * Chosen once and used everywhere (portal form, chart grouping) since no unit
 * conversion happens anywhere on the backend — a mismatched unit string breaks
 * classification/aggregation silently.
 */
export const WEIGHT_UNIT = "lb";
export const CALORIE_UNIT = "kcal";
export const MACRO_UNIT = "g";
export const WATER_UNIT = "mL";

const LB_PER_KG = 2.2046226218;
const ML_PER_OZ = 29.5735295625;

export const lbToKg = (lb: number): number => lb / LB_PER_KG;
export const kgToLb = (kg: number): number => kg * LB_PER_KG;

export const mlToOz = (ml: number): number => ml / ML_PER_OZ;
export const ozToMl = (oz: number): number => oz * ML_PER_OZ;

export type WeightDisplayUnit = "lb" | "kg";

export const lbToDisplayWeight = (lb: number, unit: WeightDisplayUnit): number => (unit === "kg" ? lbToKg(lb) : lb);

export const displayWeightToLb = (value: number, unit: WeightDisplayUnit): number =>
  unit === "kg" ? kgToLb(value) : value;
